import { Grid } from "@mui/material";
import Seccion_Items from "../Seccion_Items";

const Crear_Clientes = () => {
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'center'}
            size={{ xs: 12, sm: 12, md: 12 }}
        >
            <Seccion_Items
                coleccion="cono-gratis"
                mostrarCrear={false}
                mostrarEditar={false}
            />
        </Grid>
    );
};

export default Crear_Clientes;